export default "__VITE_ASSET__sZBkIoeO__"